import CategoryModal from './CategoryModal';

export default CategoryModal;
